import Close from '@mui/icons-material/Close';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

interface EmailSuccessModalProps {
  isOpen: boolean;
  onResolve: () => void;
}

export const EmailSuccessModal = ({ isOpen, onResolve }: EmailSuccessModalProps) => {
  const { t } = useTranslation();
  return (
    <Dialog open={isOpen} onClose={onResolve}>
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant="h6" color="text.primary">
          {t('share_document_v3.email_success_modal.title')}
        </Typography>
        <IconButton onClick={onResolve}>
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1" color="text.primary">
          {t('share_document_v3.email_success_modal.description')}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="primary" onClick={onResolve}>
          {t('share_document_v3.email_success_modal.confirm_button')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
